import { AccessDeniedScreen } from '@slims-pro/ui/organisms';
import type { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { useMe } from '@/hooks/use-me';
import { useMeta } from '@/hooks/use-meta';
import { RouterLink } from '@/lib/router-link';
import type { ExtFeatureKey, FeatureKey } from '@slims-pro/client-config';
import type { ModuleId } from '@/modules/registry';

/** Disabled module → home; enabled but not permitted → access denied. The API enforces the same. */
export function RequireModule({
	id,
	feature,
	children,
}: {
	id: ModuleId;
	feature?: FeatureKey | ExtFeatureKey;
	children: ReactNode;
}) {
	const meta = useMeta().data; // loaded by ProtectedRoute, never undefined here
	const me = useMe().data;
	if (!meta?.modules.includes(id)) return <Navigate to="/" replace />;
	if (feature && !meta.features.includes(feature)) return <Navigate to="/" replace />;
	if (!me?.permissions.some((p) => p.module === id)) {
		return <AccessDeniedScreen actionHref="/" linkComponent={RouterLink} />;
	}
	return children;
}
